var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-pl",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M640 480H0V0h640z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dc143c",
    d: "M640 480H0V240h640z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPl);
export default __webpack_public_path__ + "static/media/pl.2b5541c54505328dbc1b264a72369d23.svg";
export { ForwardRef as ReactComponent };